import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _AdquisitionItem, _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { ContractService } from "../../../../../../core/services/ContractService";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    exportMap: Function;
    procedure: any;
    stateChange: number;
}

export const ObsUpdateAdquisitionItem = ({ exportMap, procedure, stateChange }: Props) => {

    const { bean, setBean, instance } = useDataBean(_AdquisitionItem);
    const _inbox = useDataBean(_Inbox);
    const [object, setObect] = useState<any>({})
    const [obs, setObs] = useState<string>("")
    const [invalid, setInvalid] = useState<boolean>(false)
    const service = new ContractService();

    const onExportMap = (description: string) => {
        exportMap({
            Response: `${description}`,
        })
    }

    useEffect(() => {
        getItem();
    }, [procedure])

    const getItem = () => {
        _inbox.instance.getRequestProcessBpmByImp(procedure.IDProcedureImp).then(
            (resp) => {
                console.log(resp)
                if (resp.JSONProps) {
                    const x = JSON.parse(resp.JSONProps)
                    setObect(x)
                } else {
                    toast.error("error en obtener datos");
                }
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("error en obtener datos");
            }
        )
    }

    const updateState = () => {
        if (!obs || obs.length < 15 && object.IDAdquisitionItem) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.")
            setInvalid(true);
        } else {
            instance.changeAdquisitionItemApprovalNote(object.IDAdquisitionItem, _single.getAccountID(), obs, stateChange).then(
                (resp: any) => {
                    onExportMap(obs);
                }
            ).catch(
                err => { console.log(err) }
            )
        }
    }

    return (
        <div className="row d-flex justify-content-between">
            <div className="col-md-12 mb-2">
                <label>Observaciones</label>
                <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }} />
            </div>
            <div className="col-md-4">
                <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { updateState() }} >Confirmar</BasicButton>
            </div>
        </div>
    );
};